// extracted by mini-css-extract-plugin
export var backLink = "IconArrow-module--backLink--76165";
export var center = "IconArrow-module--center--4123b";
export var iconArrow = "IconArrow-module--iconArrow--43df9";
export var inner = "IconArrow-module--inner--3afca";
export var tail = "IconArrow-module--tail--b98f2";